// extracted by mini-css-extract-plugin
export default {"copy":"EmailCopy_copy__IMIYd","tooltip":"EmailCopy_tooltip__TYq5M","icon":"EmailCopy_icon__GU5X5"};